import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import { BaseIcon } from '@/lib/components/Icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchSelectItem',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  dark: {
    type: Boolean,
    default: false
  }
},
  emits: ["update:modelValue"],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-row items-center cursor-pointer justify-between p-4 rounded", 
      __props.dark
        ? 'text-gray-400 hover:bg-gray-700 hover:text-white focus:bg-gray-700 focus:text-white'
        : 'text-gray-500 bg-white hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:text-gray-900'
    ]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', !__props.modelValue)))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["truncate", __props.modelValue ? (__props.dark ? 'text-white' : 'text-gray-900') : ''])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["rounded-full flex items-center p-2", {
        'bg-gray-800 text-white': __props.modelValue && __props.dark,
        'bg-gray-100 text-gray-900': __props.modelValue && !__props.dark
      }])
    }, [
      _createVNode(_unref(BaseIcon), {
        name: __props.modelValue ? 'tick' : 'add'
      }, null, 8, ["name"])
    ], 2)
  ], 2))
}
}

})